import classNames from 'classnames'

import {colorCodes} from 'definitions/constant'
import {SvgIcon} from './SvgIcon'

export const LinkIcon: SvgIcon = ({
  width = 25,
  height = 13,
  strokeColor = 'white',
  strokeWidth = 1.2,
  fillColor = '#00000000',
  classes,
  datacy = 'link-icon',
}) => (
  <svg
    aria-hidden="true"
    width={width}
    height={height}
    fill={fillColor}
    data-cy={datacy}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 18 18"
    className={`stroke-current ${classes}`}
  >
    <path
      strokeWidth={strokeWidth}
      d="M12.5625 9.93784L13.5 9.00034C14.7426 7.7577 14.7426 5.74298 13.5 4.50034C12.2574 3.2577 10.2426 3.2577 9 4.50034L8.0625 5.43784"
      stroke={strokeColor}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      strokeWidth={strokeWidth}
      d="M5.43784 8.0625L4.50034 9C3.2577 10.2426 3.2577 12.2574 4.50034 13.5C5.74298 14.7426 7.7577 14.7426 9.00034 13.5L9.93784 12.5625"
      stroke={strokeColor}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      strokeWidth={strokeWidth}
      d="M10.6875 7.3125L7.3125 10.6875"
      stroke={strokeColor}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const CopyIcon: SvgIcon = ({
  width = 25,
  height = 13,
  strokeColor = 'text-white',
  strokeWidth = 1.2,
  fillColor = '#00000000',
  classes,
  onClick,
  datacy = 'copy-link',
}) => (
  <svg
    aria-hidden="true"
    data-cy={datacy}
    onClick={onClick}
    width={width}
    height={height}
    fill={fillColor}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    className={`copy-icon-svg stroke-current ${strokeColor} ${classes}`}
  >
    <path
      strokeWidth={strokeWidth}
      d="M6.5 15.25C5.5335 15.25 4.75 14.4665 4.75 13.5V6.75C4.75 5.64543 5.64543 4.75 6.75 4.75H13.5C14.4665 4.75 15.25 5.5335 15.25 6.5"
      stroke={strokeColor}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      strokeWidth={strokeWidth}
      d="M8.75 10.75C8.75 9.64543 9.64543 8.75 10.75 8.75H17.25C18.3546 8.75 19.25 9.64543 19.25 10.75V17.25C19.25 18.3546 18.3546 19.25 17.25 19.25H10.75C9.64543 19.25 8.75 18.3546 8.75 17.25V10.75Z"
      stroke={strokeColor}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const SearchIcon: SvgIcon = ({
  width = 24,
  height = 24,
  strokeColor = 'text-white',
  strokeWidth = 1.2,
  fillColor = '#00000000',
  classes,
  onClick,
  datacy = 'search-icon',
}) => (
  <svg
    aria-hidden="true"
    data-cy={datacy}
    onClick={onClick}
    width={width}
    height={height}
    fill={fillColor}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    className={`stroke-current ${strokeColor} ${classes}`}
  >
    <path
      d="M11 4.75C7.54822 4.75 4.75 7.54822 4.75 11C4.75 14.4518 7.54822 17.25 11 17.25C14.4518 17.25 17.25 14.4518 17.25 11C17.25 7.54822 14.4518 4.75 11 4.75Z"
      stroke={strokeColor}
      strokeWidth={strokeWidth}
    />
    <path
      d="M19.25 19.25L15.5 15.5"
      stroke={strokeColor}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
    />
  </svg>
)

export const WifiIcon: SvgIcon = ({
  width = 24,
  height = 24,
  strokeColor = 'text-white',
  strokeWidth = 1.2,
  fillColor = '#00000000',
  classes,
  onClick,
}) => (
  <svg
    aria-hidden="true"
    data-cy="wifi-icon"
    onClick={onClick}
    width={width}
    height={height}
    fill={fillColor}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    className={`stroke-current ${strokeColor} ${classes}`}
  >
    <path
      d="M12.5 18C12.5 18.2761 12.2761 18.5 12 18.5C11.7239 18.5 11.5 18.2761 11.5 18C11.5 17.7239 11.7239 17.5 12 17.5C12.2761 17.5 12.5 17.7239 12.5 18Z"
      stroke="#00D37E"
    />
    <path
      d="M9.5 14.5627C10.2016 14.0516 11.0656 13.75 12 13.75C12.9344 13.75 13.7984 14.0516 14.5 14.5627"
      stroke="#00D37E"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.7123 11.2276C15.3763 10.2962 13.7518 9.75 11.9997 9.75C10.2476 9.75 8.62309 10.2962 7.28711 11.2276"
      stroke="#00D37E"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5 7.94571C6.98421 6.56168 9.39732 5.75 12 5.75C14.6027 5.75 17.0158 6.56168 19 7.94571"
      stroke="#00D37E"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const NoWifiIcon: SvgIcon = ({
  width = 24,
  height = 24,
  strokeColor = 'text-red-100',
  strokeWidth = 1.5,
  classes = '',
}) => (
  <svg
    aria-hidden="true"
    width={width}
    height={height}
    viewBox={`0 0 ${width} ${height}`}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={`${strokeColor} ${classes}`}
  >
    <path
      d="M12.5 18C12.5 18.2761 12.2761 18.5 12 18.5C11.7239 18.5 11.5 18.2761 11.5 18C11.5 17.7239 11.7239 17.5 12 17.5C12.2761 17.5 12.5 17.7239 12.5 18Z"
      className="stroke-current"
    />
    <path
      d="M9.5 14.5627C10.2016 14.0516 11.0656 13.75 12 13.75C12.9344 13.75 13.7984 14.0516 14.5 14.5627"
      className="stroke-current"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.28711 11.2277C8.19107 10.5975 9.22713 10.1436 10.3454 9.91602M14.1789 10.041C15.0972 10.2918 15.9515 10.6973 16.7123 11.2277"
      className="stroke-current"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.75 8.25C6.73421 6.86597 9 5.75 12 5.75C12.6875 5.75 13.3364 5.8086 13.9522 5.9156M17.3354 7.07854C18.0087 7.42768 18.6425 7.82628 19.25 8.25"
      className="stroke-current"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18.25 5.75L6.75 17.25"
      className="stroke-current"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const ArrowRightSmIcon: SvgIcon = ({
  width = 24,
  height = 24,
  strokeColor = 'text-white',
  strokeWidth = 1.2,
  fillColor = '#00000000',
  classes = '',
  onClick,
  ariaLabel = 'Arrow Right Icon',
}) => (
  <svg
    data-cy="sm-arrow-icon"
    onClick={onClick}
    width={width}
    height={height}
    fill={fillColor}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    className={`stroke-current ${strokeColor} ${classes}`}
    role="img"
    aria-label={ariaLabel}
  >
    <path
      d="M13.75 6.75L19.25 12L13.75 17.25"
      className={`stroke-current`}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19 12H4.75"
      className={`stroke-current`}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const ArrowRightXsIcon: SvgIcon = ({
  width = 12,
  height = 10,
  strokeColor = 'text-white',
  strokeWidth = 1.5,
  fillColor = 'none',
  classes,
  onClick,
}) => (
  <svg
    aria-hidden="true"
    data-cy="xs-arrow-icon"
    onClick={onClick}
    width={width}
    height={height}
    fill={fillColor}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 12 10"
    className={`stroke-current ${strokeColor} ${classes}`}
  >
    <path
      d="M7.58325 1.71899L11.2499 5.00024L7.58325 8.28149M11.0833 5.00024H1.58325"
      strokeOpacity="1"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const MailIcon: SvgIcon = ({
  width = 24,
  height = 24,
  strokeColor = 'text-white',
  strokeWidth = 1.2,
  fillColor = '#00000000',
  classes,
  onClick,
}) => (
  <svg
    aria-hidden="true"
    data-cy="mail-icon"
    onClick={onClick}
    width={width}
    height={height}
    fill={fillColor}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    className={`stroke-current ${strokeColor} ${classes}`}
  >
    <path
      d="M3.5625 5.8125C3.5625 4.98407 4.23407 4.3125 5.0625 4.3125H12.9375C13.7659 4.3125 14.4375 4.98407 14.4375 5.8125V12.1875C14.4375 13.0159 13.7659 13.6875 12.9375 13.6875H5.0625C4.23407 13.6875 3.5625 13.0159 3.5625 12.1875V5.8125Z"
      stroke="#919699"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.125 4.875L9 9.1875L13.875 4.875"
      stroke="#919699"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const LockIcon: SvgIcon = ({
  width = 36,
  height = 36,
  strokeColor = 'text-white',
  strokeWidth = 1.2,
  fillColor = '#00000000',
  classes,
  onClick,
}) => (
  <svg
    aria-hidden="true"
    data-cy="mail-icon"
    onClick={onClick}
    width={width}
    height={height}
    fill={fillColor}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 36 36"
    className={`stroke-current ${strokeColor} ${classes}`}
  >
    <path
      d="M8.625 17.625C8.625 16.7966 9.29657 16.125 10.125 16.125H25.875C26.7034 16.125 27.375 16.7966 27.375 17.625V25.875C27.375 27.5319 26.0319 28.875 24.375 28.875H11.625C9.96815 28.875 8.625 27.5319 8.625 25.875V17.625Z"
      stroke="white"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.625 15.75V15.514C11.625 13.1722 11.4841 10.5619 13.1197 8.88585C14.0524 7.93005 15.5618 7.125 18 7.125C20.4382 7.125 21.9476 7.93005 22.8803 8.88585C24.5159 10.5619 24.375 13.1722 24.375 15.514V15.75"
      stroke="white"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const RefreshIcon: SvgIcon = ({
  width = 24,
  height = 24,
  strokeColor = 'text-white',
  strokeWidth = 1.2,
  fillColor = '#00000000',
  classes,
  onClick,
}) => (
  <svg
    aria-hidden="true"
    data-cy="refresh-icon"
    onClick={onClick}
    width={width}
    height={height}
    fill={fillColor}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    className={`stroke-current ${strokeColor} ${classes}`}
  >
    <path
      d="M11.25 4.75L8.75 7L11.25 9.25"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.75 19.25L15.25 17L12.75 14.75"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.75 7H13.25C16.5637 7 19.25 9.68629 19.25 13V13.25"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.25 17H10.75C7.43629 17 4.75 14.3137 4.75 11V10.75"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const DopePaymentLogo: SvgIcon = ({
  width = 82,
  height = 12,
  classes,
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 82 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={classes}
    aria-hidden="true"
  >
    <path
      d="M3.872 11C6.672 11 9.052 9.18 9.052 6.03C9.052 2.964 6.672 1.2 3.872 1.2H0.176V11H3.872ZM2.304 2.964H3.858C5.874 2.964 6.854 4.21 6.854 6.072C6.854 8.144 5.86 9.236 3.774 9.236H2.304V2.964ZM15.4607 11.224C18.7647 11.224 20.6967 9.068 20.6967 6.128C20.6967 3.202 18.7227 0.976 15.4607 0.976C12.1987 0.976 10.2247 3.202 10.2247 6.128C10.2247 9.068 12.1567 11.224 15.4607 11.224ZM15.4747 9.46C13.5567 9.46 12.4507 8.032 12.4507 6.114C12.4507 4.168 13.5567 2.74 15.4747 2.74C17.3787 2.74 18.4707 4.168 18.4707 6.114C18.4707 8.032 17.3787 9.46 15.4747 9.46ZM24.5892 11V7.556H26.8712C28.9572 7.556 30.3992 6.31 30.3992 4.364C30.3992 2.418 28.9572 1.2 26.8572 1.2H22.4612V11H24.5892ZM24.5892 2.964H26.4792C27.4872 2.964 28.1872 3.496 28.1872 4.364C28.1872 5.274 27.4872 5.792 26.4792 5.792H24.5892V2.964ZM39.3144 11V9.236H34.0364V6.828H38.0264V5.092H34.0364V2.964H39.3144V1.2H31.9084V11H39.3144ZM42.5366 11V8.676H40.6746V11H42.5366ZM45.1039 2.586C45.2999 1.746 46.4759 1.158 47.8899 1.2C47.8899 1.2 49.4999 1.214 50.1999 2.026C50.7319 2.726 51.1099 3.72 51.2499 4.126V1.928C50.9139 1.662 50.4379 1.452 50.2279 1.368C49.4439 1.102 48.5199 1.018 48.0719 0.99C45.9859 0.85 44.1379 2.138 44.0399 3.72C43.9139 5.442 45.3979 6.198 47.2879 6.828C50.2139 7.794 51.5719 8.494 51.6559 11.098C54.1479 7.458 48.9959 6.128 48.9959 6.128C44.4179 4.742 45.0199 2.81 45.1039 2.586ZM46.0559 10.37C45.2859 9.53 44.9499 8.186 44.9499 8.186V10.468C45.2719 10.678 45.6499 10.846 46.0559 10.972V10.37ZM70.5342 1.2H70.0442L65.2002 9.866L61.1962 1.214H59.6562L61.5462 5.246L59.1802 10.02L54.5882 1.214H52.9082L58.3122 11H59.3622L61.8262 5.848L64.3182 11H65.2562L70.5342 1.2ZM78.3078 7.346L80.0858 7.36C80.0578 8.76 79.2038 9.642 78.9518 9.866C78.2238 10.468 77.3138 10.818 76.3198 10.818C73.9678 10.818 72.2738 8.858 72.2738 6.142C72.2738 4 73.3238 2.306 74.9058 1.676C75.3118 1.508 76.4458 1.13 77.6498 1.536C79.3578 2.04 79.6238 3.832 80.1558 4.336L80.0858 1.872C79.6938 1.76 78.9938 1.41 78.0418 1.214C77.4258 1.074 76.8518 1.032 76.3478 1.046C74.5558 1.032 73.1838 1.928 73.1838 1.928C71.6438 2.838 70.7478 4.378 70.7478 6.128C70.7478 8.9 73.1278 11.14 76.3198 11.168C77.9578 11.154 79.4418 10.552 80.4918 9.6C80.9538 9.068 81.3878 8.564 81.4718 7.164V6.282H79.1898L78.3078 7.346Z"
      fill="white"
    />
  </svg>
)

export const AmexPaymentIcon: SvgIcon = () => (
  <svg
    aria-hidden="true"
    width="28"
    height="8"
    viewBox="0 0 28 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.73617 0.555664L0.742188 6.99721H4.32641L4.77075 5.97016H5.78641L6.23075 6.99721H10.176V6.21334L10.5275 6.99721H12.5683L12.9198 6.19677V6.99721H21.1248L22.1225 5.99683L23.0567 6.99721L27.271 7.0055L24.2675 3.79442L27.271 0.555664H23.1221L22.1509 1.53756L21.2461 0.555664H12.3201L11.5537 2.21828L10.7692 0.555664H7.19248V1.31287L6.79459 0.555664H3.73617ZM15.9886 1.47038H20.7003L22.1414 2.98378L23.629 1.47038H25.07L22.8805 3.79352L25.07 6.08989H23.5636L22.1225 4.55891L20.6274 6.08989H15.9886V1.47038ZM17.1522 3.27119V2.4274V2.4266H20.0921L21.375 3.77603L20.0353 5.13284H17.1522V4.21166H19.7226V3.27119H17.1522ZM4.4297 1.47038H6.17682L8.16273 5.83843V1.47038H10.0766L11.6105 4.60225L13.0242 1.47038H14.9285V6.09261H13.7698L13.7603 2.47066L12.071 6.09261H11.0344L9.33561 2.47066V6.09261H6.95181L6.49989 5.05637H4.05831L3.60732 6.0917H2.33011L4.4297 1.47038ZM4.47521 4.09842L5.27961 2.25243L6.08308 4.09842H4.47521Z"
      fill="#F7F9FA"
    />
  </svg>
)

export const VisaPaymentIcon: SvgIcon = () => (
  <svg
    aria-hidden="true"
    width="38"
    height="22"
    viewBox="0 0 38 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.3855 14.4508H9.11354L7.40988 9.05976C7.32901 8.81177 7.15732 8.59254 6.90476 8.48921C6.27447 8.22954 5.57994 8.02288 4.82227 7.91866V7.7111H8.48214C8.98726 7.7111 9.36609 8.02288 9.42923 8.38498L10.3132 12.2737L12.584 7.7111H14.7928L11.3855 14.4508ZM16.0556 14.4508H13.9099L15.6767 7.7111H17.8224L16.0556 14.4508ZM20.5983 9.5782C20.6614 9.21521 21.0403 9.00765 21.4822 9.00765C22.1768 8.95554 22.9333 9.05977 23.5647 9.31854L23.9436 7.86745C23.3122 7.65989 22.6176 7.55566 21.9874 7.55566C19.9049 7.55566 18.3895 8.48921 18.3895 9.78486C18.3895 10.7705 19.4629 11.2881 20.2206 11.5998C21.0403 11.9107 21.356 12.1183 21.2928 12.4292C21.2928 12.8955 20.6614 13.103 20.0311 13.103C19.2735 13.103 18.5158 12.9476 17.8224 12.6879L17.4435 14.1399C18.2012 14.3987 19.0209 14.5029 19.7786 14.5029C22.1136 14.5541 23.5647 13.6215 23.5647 12.2216C23.5647 10.4587 20.5983 10.3554 20.5983 9.5782V9.5782ZM31.0739 14.4508L29.3702 7.7111H27.5403C27.1615 7.7111 26.7826 7.91866 26.6564 8.22954L23.5016 14.4508H25.7104L26.1512 13.466H28.8651L29.1177 14.4508H31.0739ZM27.856 9.52609L28.4863 12.0662H26.7195L27.856 9.52609Z"
      fill="#F7F9FA"
    />
  </svg>
)

export const MasterCardPaymentIcon: SvgIcon = () => (
  <svg
    aria-hidden="true"
    width="33"
    height="22"
    viewBox="0 0 33 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.731 15.2505C15.6416 16.1645 14.2284 16.7163 12.6842 16.7163C9.23855 16.7163 6.44531 13.9691 6.44531 10.5803C6.44531 7.19151 9.23855 4.44434 12.6842 4.44434C14.2284 4.44434 15.6416 4.99611 16.731 5.91014C17.8205 4.99611 19.2336 4.44434 20.7779 4.44434C24.2235 4.44434 27.0167 7.19151 27.0167 10.5803C27.0167 13.9691 24.2235 16.7163 20.7779 16.7163C19.2336 16.7163 17.8205 16.1645 16.731 15.2505Z"
      fill="white"
      fillOpacity="0.6"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.7305 15.2505C18.0719 14.1251 18.9225 12.4504 18.9225 10.5803C18.9225 8.71026 18.0719 7.03559 16.7305 5.91014C17.8199 4.99611 19.2331 4.44434 20.7773 4.44434C24.2229 4.44434 27.0162 7.19151 27.0162 10.5803C27.0162 13.9691 24.2229 16.7163 20.7773 16.7163C19.2331 16.7163 17.8199 16.1645 16.7305 15.2505Z"
      fill="#F7F9FA"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.7311 15.2505C15.3896 14.125 14.5391 12.4504 14.5391 10.5803C14.5391 8.71027 15.3896 7.03561 16.7311 5.91016C18.0725 7.03561 18.9231 8.71027 18.9231 10.5803C18.9231 12.4504 18.0725 14.125 16.7311 15.2505Z"
      fill="white"
      fillOpacity="0.5"
    />
  </svg>
)

export const DiscoverPaymentIcon: SvgIcon = () => (
  <svg
    aria-hidden="true"
    width="33"
    height="22"
    viewBox="0 0 33 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M28.6035 8.54287C29.5969 8.54287 30.1433 8.97269 30.1433 9.78456C30.1929 10.4054 29.7459 10.9307 29.1498 11.0263L30.491 12.7933H29.4479L28.3054 11.074H28.2061V12.7933H27.3617V8.54287H28.6035ZM28.2061 10.5009H28.4544C29.0008 10.5009 29.2492 10.2621 29.2492 9.83231C29.2492 9.45025 29.0008 9.21147 28.4544 9.21147H28.2061V10.5009ZM24.4311 12.7933H26.8153V12.0769H25.2755V10.9307H26.7656V10.2144H25.2755V9.25923H26.8153V8.54287H24.4311V12.7933V12.7933ZM21.9475 11.4083L20.8051 8.54287H19.911L21.7488 12.8888H22.1959L24.0337 8.54287H23.1396L21.9475 11.4083V11.4083ZM11.8643 10.6919C11.8643 11.8859 12.8577 12.8888 14.0995 12.8888C14.4968 12.8888 14.8445 12.7933 15.1922 12.65V11.6948C14.9439 11.9814 14.5962 12.1724 14.1988 12.1724C13.4041 12.1724 12.7584 11.5993 12.7584 10.8352V10.7397C12.7087 9.97559 13.3544 9.30698 14.1492 9.25923C14.5465 9.25923 14.9439 9.45026 15.1922 9.7368V8.78165C14.8942 8.59063 14.4968 8.54287 14.1492 8.54287C12.8577 8.44735 11.8643 9.45026 11.8643 10.6919V10.6919ZM10.3245 10.1666C9.82777 9.97559 9.67875 9.88007 9.67875 9.64129C9.72842 9.35474 9.97678 9.11595 10.2748 9.16371C10.5232 9.16371 10.7715 9.30698 10.9702 9.49801L11.4172 8.92493C11.0695 8.63838 10.6225 8.44735 10.1755 8.44735C9.48007 8.3996 8.88401 8.92493 8.83434 9.59353V9.64129C8.83434 10.2144 9.0827 10.5487 9.87744 10.7875C10.0761 10.8352 10.2748 10.9307 10.4735 11.0262C10.6225 11.1218 10.7218 11.265 10.7218 11.4561C10.7218 11.7904 10.4238 12.0769 10.1258 12.0769H10.0761C9.67875 12.0769 9.33105 11.8381 9.18204 11.5038L8.63566 12.0292C8.93369 12.5545 9.52974 12.841 10.1258 12.841C10.9205 12.8888 11.5663 12.3157 11.6159 11.5516V11.4083C11.5663 10.8352 11.3179 10.5487 10.3245 10.1666V10.1666ZM7.44355 12.7933H8.28796V8.54287H7.44355V12.7933V12.7933ZM3.51953 8.54287H4.76131H5.00967C6.20177 8.59063 7.14552 9.54578 7.09585 10.692C7.09585 11.3128 6.79783 11.8859 6.30112 12.3157C5.85407 12.65 5.30769 12.841 4.76131 12.7933H3.51953V8.54287ZM4.61229 12.0769C5.00966 12.1247 5.4567 11.9814 5.75473 11.7426C6.05276 11.4561 6.20177 11.074 6.20177 10.6442C6.20177 10.2621 6.05276 9.88008 5.75473 9.59353C5.4567 9.35475 5.00966 9.21148 4.61229 9.25923H4.36394V12.0769H4.61229Z"
      fill="#F7F9FA"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.7263 8.44434C16.4845 8.44434 15.4414 9.39948 15.4414 10.6412C15.4414 11.8351 16.4348 12.838 17.7263 12.8858C19.0177 12.9335 20.0112 11.9306 20.0608 10.6889C20.0112 9.44724 19.0177 8.44434 17.7263 8.44434V8.44434Z"
      fill="#F7F9FA"
    />
  </svg>
)

export const ACHPaymentIcon: SvgIcon = () => (
  <svg
    aria-hidden="true"
    width="32"
    height="22"
    viewBox="0 0 32 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.75195 13.9052L8.96195 7.41516H10.442L12.562 13.9052H11.322L10.872 12.5052H8.46195L8.00195 13.9052H6.75195ZM8.76195 11.6152H10.592L9.68195 8.82516L8.76195 11.6152Z"
      fill="#F7F9FA"
    />
    <path
      d="M16.0817 14.0452C15.5117 14.0452 15.0151 13.9102 14.5917 13.6402C14.1717 13.3668 13.8451 12.9768 13.6117 12.4702C13.3784 11.9635 13.2617 11.3552 13.2617 10.6452C13.2617 9.91182 13.3817 9.29682 13.6217 8.80016C13.8651 8.30016 14.1984 7.92349 14.6217 7.67016C15.0484 7.41349 15.5351 7.28516 16.0817 7.28516C16.8384 7.28516 17.4284 7.46849 17.8517 7.83516C18.2784 8.20182 18.5517 8.67849 18.6717 9.26516L17.4117 9.49516C17.3084 9.15516 17.1434 8.88016 16.9167 8.67016C16.6901 8.46016 16.4117 8.35516 16.0817 8.35516C15.7917 8.35516 15.5301 8.44016 15.2967 8.61016C15.0634 8.77682 14.8767 9.03016 14.7367 9.37016C14.6001 9.71016 14.5317 10.1352 14.5317 10.6452C14.5317 11.1252 14.5917 11.5385 14.7117 11.8852C14.8351 12.2318 15.0117 12.4985 15.2417 12.6852C15.4717 12.8718 15.7517 12.9652 16.0817 12.9652C16.5051 12.9652 16.8317 12.8535 17.0617 12.6302C17.2951 12.4035 17.4117 12.1152 17.4117 11.7652H18.6717C18.6717 12.2485 18.5667 12.6602 18.3567 13.0002C18.1501 13.3368 17.8534 13.5952 17.4667 13.7752C17.0801 13.9552 16.6184 14.0452 16.0817 14.0452Z"
      fill="#F7F9FA"
    />
    <path
      d="M20.0596 7.41516H21.2396V10.1252H24.0696V7.41516H25.2496V13.9052H24.0696V11.1552H21.2396V13.9052H20.0596V7.41516Z"
      fill="#F7F9FA"
    />
  </svg>
)

export const ClockIcon: SvgIcon = ({
  width = 16,
  height = 16,
  strokeColor = 'text-white',
  fillColor = '#00000000',
  classes,
  onClick,
}) => (
  <svg
    aria-hidden="true"
    width={width}
    height={height}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    onClick={onClick}
    floodColor={fillColor}
    className={classes}
  >
    <path
      d="M12.8327 7.99984C12.8327 10.6692 10.6687 12.8332 7.99935 12.8332C5.32997 12.8332 3.16602 10.6692 3.16602 7.99984C3.16602 5.33046 5.32997 3.1665 7.99935 3.1665C10.6687 3.1665 12.8327 5.33046 12.8327 7.99984Z"
      stroke={strokeColor}
    />
    <path
      d="M8 5.3335V8.00016L9.33333 9.3335"
      stroke={strokeColor}
      strokeLinecap="round"
    />
  </svg>
)

export const AwardIcon: SvgIcon = ({
  width = 16,
  height = 16,
  strokeColor = 'text-white',
  fillColor = '#00000000',
  classes,
  onClick,
}) => (
  <svg
    aria-hidden="true"
    width={width}
    height={height}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    floodColor={fillColor}
    className={classes}
    onClick={onClick}
  >
    <path
      d="M11.5 6.6665C11.5 8.5995 9.933 10.1665 8 10.1665C6.067 10.1665 4.5 8.5995 4.5 6.6665C4.5 4.73351 6.067 3.1665 8 3.1665C9.933 3.1665 11.5 4.73351 11.5 6.6665Z"
      stroke={strokeColor}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.83268 9.8335L5.16602 12.8335L7.99935 11.8335L10.8327 12.8335L10.166 9.8335"
      stroke={strokeColor}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const PaymentWarningIcon: SvgIcon = () => (
  <svg
    aria-hidden="true"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.9341 5.16107C10.55 4.39438 9.4559 4.39418 9.07157 5.16073L4.68572 13.9082C4.33842 14.6009 4.84204 15.4168 5.6169 15.4168H14.3846C15.1593 15.4168 15.6629 14.6012 15.3159 13.9086L10.9341 5.16107ZM7.95415 4.60048C8.79968 2.91408 11.2068 2.91452 12.0517 4.60123L16.4335 13.3487C17.1969 14.8726 16.0889 16.6668 14.3846 16.6668H5.6169C3.91221 16.6668 2.80426 14.8719 3.5683 13.348L7.95415 4.60048Z"
      fill="#4BD1FF"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.99935 7.5C10.4596 7.5 10.8327 7.8731 10.8327 8.33333V10C10.8327 10.4602 10.4596 10.8333 9.99935 10.8333C9.53911 10.8333 9.16602 10.4602 9.16602 10V8.33333C9.16602 7.8731 9.53911 7.5 9.99935 7.5Z"
      fill="#4BD1FF"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.16602 13.3333C9.16602 12.8731 9.53911 12.5 9.99935 12.5C10.4596 12.5 10.8327 12.8731 10.8327 13.3333C10.8327 13.7936 10.4596 14.1667 9.99935 14.1667C9.53911 14.1667 9.16602 13.7936 9.16602 13.3333Z"
      fill="#4BD1FF"
    />
  </svg>
)

export const WindowsIconForUserGroups: SvgIcon = () => (
  <svg
    aria-hidden="true"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <rect width="16" height="16" fill="url(#pattern0)" />
    <defs>
      <pattern
        id="pattern0"
        patternContentUnits="objectBoundingBox"
        width="1"
        height="1"
      >
        <use xlinkHref="#image0_21237_682" transform="scale(0.047619)" />
      </pattern>
      <image
        id="image0_21237_682"
        width="21"
        height="21"
        xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAVCAYAAACpF6WWAAAAVklEQVQ4EWNgoBX4FKD0nxAG2V2/i+E/IQx3IyEDQfKjho6G6UAnKXiCpSpjyfv/DIQwAwPD/50M/wlhhLsIGQiSHzWUUHiC5EfDFBoCNElSiNClCgsA6SEhUt3q3hcAAAAASUVORK5CYII="
      />
    </defs>
  </svg>
)

export const RotateIcon: SvgIcon = ({
  width = 24,
  height = 24,
  strokeColor = 'text-gray-1000',
  strokeWidth = 1.5,
  classes = '',
}) => (
  <svg
    aria-hidden="true"
    width={width}
    height={height}
    viewBox={`0 0 ${width} ${height}`}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={`${strokeColor} ${classes}`}
  >
    <path
      d="M17.1265 6.87348C14.2952 4.04217 9.70478 4.04217 6.87348 6.87348C4.04217 9.70478 4.04217 14.2952 6.87348 17.1265C9.70478 19.9578 14.2952 19.9578 17.1265 17.1265C17.7603 16.4927 18.2522 15.7708 18.6023 15.0001"
      className="stroke-current"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19.25 19.25V15.75C19.25 15.1977 18.8023 14.75 18.25 14.75H14.75"
      className="stroke-current"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const Add: SvgIcon = ({
  width = 24,
  height = 24,
  fillColor = colorCodes.white,
  classes = '',
}) => (
  <svg
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
    height={height}
    viewBox="0 -960 960 960"
    width={width}
    className={classes}
    fill={fillColor}
  >
    <path d="M440-440H240q-17 0-28.5-11.5T200-480q0-17 11.5-28.5T240-520h200v-200q0-17 11.5-28.5T480-760q17 0 28.5 11.5T520-720v200h200q17 0 28.5 11.5T760-480q0 17-11.5 28.5T720-440H520v200q0 17-11.5 28.5T480-200q-17 0-28.5-11.5T440-240v-200Z" />
  </svg>
)

export const PencilIcon: SvgIcon = ({
  width = 24,
  height = 24,
  onClick,
  classes,
}) => (
  <svg
    aria-hidden="true"
    width={width}
    height={height}
    viewBox={`0 0 ${width} ${height}`}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={classNames(classes)}
    onClick={onClick}
  >
    <path
      d="M4.75 19.2498L9 18.2498L18.9491 8.3007C19.3397 7.91018 19.3397 7.27702 18.9491 6.88649L17.1134 5.05071C16.7228 4.66018 16.0897 4.66018 15.6991 5.05071L5.75 14.9998L4.75 19.2498Z"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.0234 7.03906L17.0234 10.0391"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const PencilIconCorrect: SvgIcon = ({
  width = 24,
  height = 24,
  onClick,
  classes,
}) => (
  <svg
    aria-hidden="true"
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={classNames(classes)}
    onClick={onClick}
  >
    <path
      d="M4.75 19.2498L9 18.2498L18.9491 8.3007C19.3397 7.91018 19.3397 7.27702 18.9491 6.88649L17.1134 5.05071C16.7228 4.66018 16.0897 4.66018 15.6991 5.05071L5.75 14.9998L4.75 19.2498Z"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.0234 7.03906L17.0234 10.0391"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
